var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "metric-tile" }, [
    _c(
      "span",
      { staticClass: "metric-tile__label" },
      [
        _vm._t("label", function() {
          return [_vm._v(_vm._s(_vm.label))]
        })
      ],
      2
    ),
    _vm._v(" "),
    _c("span", { staticClass: "metric-tile__value" }, [
      _vm._v(_vm._s(_vm.value))
    ]),
    _vm._v(" "),
    _vm.caption
      ? _c("span", { staticClass: "metric-tile__caption" }, [
          _vm._v(_vm._s(_vm.caption))
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7b59e524", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b59e524","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/auditLog/MetricTile.vue
// module id = null
// module chunks = 